import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import { createContext, useContext, useState } from "react";
import { postPayInvoice } from "../../services/ClientArea/postPayInvoice";
import { queryClient } from "../../utils/queryClient";
//context
const UserRegistrationContext = createContext();

export function UserRegistrationProvider({ children }) {
  // states
  const form = useForm();
  const [cards, setCards] = useState([]);
  const [payment, setPayment] = useState(null);
  const [visible, setVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [contract, setContract] = useState(null);
  const [pixDataQR, setPixDataQR] = useState(null);
  const [pixClient, setPixClient] = useState(null);
  const [errorCupom, setErrorCupom] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const [itemsSelected, setItemsSelected] = useState([]);
  const [baseDataForm, setBaseDataForm] = useState(null);
  const [paymentMethod, setPaymentMethod] = useState(null);
  const [loadingButton, setLoadingButton] = useState(false);
  const [activeIndexModal, setActiveIndexModal] = useState(0);
  const [creditCardClient, setCreditCardClient] = useState(null);
  const [visiblePixPayment, setVisiblePixPayment] = useState(false);
  const [optionsInstallments, setOptionsInstallments] = useState([]);
  const [visiblePaymentMethods, setVisiblePaymentMethods] = useState(true);
  const [visibleModalCreditCard, setVisibleModalCreditCard] = useState(false);
  const [cardState, setCardState] = useState({
    card_number: "",
    expiry: "",
    cvc: "",
    name: "",
    focus: "",
  });

  // const handleInputChange = (name, value) => {
  //   setCardState((prev) => ({ ...prev, [name]: value }));
  // };

  const handleInputChange = (name, value) => {
    if (name === "expiry") {
      const [month, day] = value.split("/");
      if (month && (parseInt(month, 10) > 12 || (month !== '0_' &&  parseInt(month, 10) < 1))) {
        setCardState((prevState) => ({
          ...prevState,
          expiry: "__/__",
        }));
        return;
      } else {
        setCardState((prev) => ({ ...prev, [name]: value }));
      }
    } else {
      setCardState((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleInputFocus = (name) => {
    setCardState((prev) => ({ ...prev, focus: name }));
  };

  const isFormIncomplete = (formData) => {
    return Object.values(formData).some(
      (value) => value === null || value === ""
    );
  };

  const handleSubmit = async () => {
    if(!paymentMethod === "pix" && form.getValues("installments") === undefined){
      toast.warning("Selecioe o número de prestações");
      return;
    }
    setLoadingButton(true);
    // console.log(cards);
    // console.log(itemsSelected);
    // console.log(cardState);
    // console.log(pixClient);
    // console.log(baseDataForm);
    // console.log(creditCardClient);
    // console.log(form.getValues());
    let obj = {};

    if (paymentMethod === "card") {
      obj.payment_method = "credit_card"; 
      const [exp_month, exp_year] = cardState.expiry.split("/");
      obj.card = {
        holder_name: cardState.name,
        card_number: cardState.card_number,
        exp_month: exp_month,
        exp_year: exp_year,
        cvv: cardState.cvc,
        billing_address: {
          ...creditCardClient.address,
        },
      };
    }
    
    if (paymentMethod === "pix") {
      obj.payment_method = "pix";
    } else {
      obj.installments = form.getValues("installments");
    }
    
    if(cards.some((card) => card.active === 1)){
      obj.payment_method = "credit_card"; 
      const card = cards.find((card) => card.active === 1);
      obj.card_id = card.id;
    }

    obj.payments = itemsSelected.map((pay) => {
      return pay.id;
    })

    console.log(obj);

    try {
      const response = await postPayInvoice(obj);
      // console.log(response);
      if (response.status) {
        if (response.status === "400") {
          toast.danger("Número do cartão inválido!");
        } else {
          toast.danger("Erro no pagamento!");
        }
        setLoadingButton(false);
        return;
      }
      if (response.success.link_QRcode) {
        setPixDataQR({
          id: response.success.payment_id,
          copy: response.success.pix,
          qr_code: response.success.link_QRcode,
          timer: 7,
        });
        setVisiblePixPayment(true);
        setLoadingButton(false);
        return;
      }
      if(response.error){
        toast.danger("Erro no pagamento!");
      }
      
      queryClient.invalidateQueries(["UserOpenPayments"]);
      toast.success("Pagamento efetuado com sucesso!");
      setVisible(false);

    } catch (error) {
      console.log(error);
    }
    setLoadingButton(false);
  };

  return (
    <UserRegistrationContext.Provider
      value={{
        form,
        cards,
        payment,
        visible,
        loading,
        contract,
        setCards,
        pixClient,
        cardState,
        pixDataQR,
        errorCupom,
        setLoading,
        setPayment,
        setVisible,
        setContract,
        activeIndex,
        setPixClient,
        handleSubmit,
        setCardState,
        baseDataForm,
        setPixDataQR,
        itemsSelected,
        loadingButton,
        paymentMethod,
        setErrorCupom,
        setActiveIndex,
        setBaseDataForm,
        activeIndexModal,
        setItemsSelected,
        isFormIncomplete,
        creditCardClient,
        handleInputFocus,
        setPaymentMethod,
        visiblePixPayment,
        handleInputChange,
        setActiveIndexModal,
        optionsInstallments,
        setCreditCardClient,
        setVisiblePixPayment,
        visiblePaymentMethods,
        setOptionsInstallments,
        visibleModalCreditCard,
        setVisiblePaymentMethods,
        setVisibleModalCreditCard,
      }}
    >
      {children}
    </UserRegistrationContext.Provider>
  );
}

export function useUserRegistrationContext() {
  return useContext(UserRegistrationContext);
}
